import React, { useEffect, useRef, useState } from "react";
import { signInAsGuest, useAuth } from "../auth/FirebaseAuth.js";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { getUserById } from "../models/UserFunctions.js";
import { getOrgByRef, isColorTooDark } from "../models/OrgFunctions.js";
import downloadRapport from "../api/download/downloadRapport.js";
import Divider from "../layout/Divider.js";
import Icon1 from "../icons/Icon.js";
import Space from "../layout/Space.js";

import FoldersAM from "../pages/folder_pages/FoldersAM.js";

import {
  getDocDataById,
  getDocDataByRef,
  getArrayDocDataByRef,
  getDocumentsByFolderRef,
  queryCollection,
  listenDocDataById,
  updateDocDataField,
  getOrgDataById,
  getArrayDocDataByID,
} from "../models/DataFunctions.js";

import "../animations/animations.css";

import { getOrRefreshFirebaseToken } from "../config/getFirebaseToken.js";
import uploadDropZoneTemporary from "../api/upload/uploadDropZoneTemporary.js";

import Modal1 from "../modals/Modal1.js";

import { useSnackbar } from "notistack";
import getTemporaryUrl from "../api/getTemporaryUrl.js";
import { Skeleton } from "@mui/material";

import EmailModal from "../modals/EmailModal.js";
import { useAppContext } from "../config/AppContext.js";
import deleteFolder from "../api/delete/deleteFolder.js";

import SmallSpinner from "../loading/SmallSpinner.js";

import PrimaryButton from "../buttons/PrimaryButton.js";
import transferFolderFiles from "../api/folder/transferFolderFiles.js";

import updateDocDataFieldApi from "../api/database/updateDocDataFieldApi.js";
import FolderChatSimple from "../messages/FolderChatSimple.js";
import Dropzone2 from "../dropzones/DropZone2.js";

import SignBlockFolder from "../folder_modals/SignBlockFolder.js";
import Photo from "../photo/Photo.js";
import TFGPT1 from "../textfields/TFGPT1.js";
import { Input, Spin } from "antd";
import loadingAnimation from "../animations/loading.json"; // Path to your JSON file
import { Player } from "@lottiefiles/react-lottie-player";
import {
  sendAdminKey,
  sendSmsVerificationCall,
  VerifySmsCodeCall,
} from "../config/ApiCalls.js";
import sendErrorPaiementEmail from "../api/send/sendErrorPaiementEmail.js";
import { gatherDeviceInfo } from "../config/GatheringInfos.js";
import SecondaryButton from "../buttons/SecondaryButton.js";
import TextField2 from "../textfields/TextField2.js";
import { translateDocumentId } from "../pages/folder_pages/FolderV2.js";
import { addActivityLog } from "../config/OnlineStatus.js";
import FolderChat from "../messages/FolderChat.js";
import { check_files_are_all_zip_or_xml } from "../pages/folder_pages/FolderV2.js";
import { particulierActivated } from "../hexagone/VisibilityHelpers.js";
import TimelineFolderAudit from "../folder_modals/TimelineFolderAudit.js";
import Collapsible from "../layout/Collapsible.js";
import TimelineFolder from "../folder_modals/TimelineFolder.js";
import Tippy from "@tippyjs/react";

function FolderPortal({ navigateWorkspace, impersonate = false }) {
  const { id } = useParams(); // Access the `id` parameter from the URL
  const { currentUser, loading } = useAuth();
  const [loadingData, setLoadingData] = useState(true);

  const [searchParams] = useSearchParams();
  const redirect_payment_id = searchParams.get("redirect_payment_id");

  const [userData, setUserData] = useState(null);
  const [orgData, setOrgData] = useState(null);
  const [clientData, setClientData] = useState(null);
  const [folderData, setFolderData] = useState(null);
  const [reglementData, setReglementData] = useState(null);

  const [operators, setOperators] = useState([]);
  const [all_operators, setAllOperators] = useState([]);
  const [conductor, setConductor] = useState(null);
  const [all_conductors, setAllConductors] = useState([]);

  const [dropped_files, setDroppedFiles] = useState([]);

  const [dropped_exists, setDroppedExists] = useState(false);

  const [infiltrea, setInfiltrea] = useState(null);

  const [messages, setMessages] = useState([]);
  const [code, setCode] = useState("");

  const [emails, setEmails] = useState([]);
  const [loadingTransfer, setLoadingTransfer] = useState(null);

  const { appState, setAppState } = useAppContext();
  const prefix = appState.dev ? appState.dev_url : appState.prod_url;
  const [tag_open, setTagOpen] = useState(false);
  const [photoOpen, setPhotoOpen] = useState(false);
  const [blocks, setBlocks] = useState([]);

  const [tag_index, setTagIndex] = useState(0);

  const [chatopen, setChatOpen] = useState(false);
  const [sign_step, setSignStep] = useState(0);
  const [sign_type, setSignType] = useState("");
  const [loadingConfirm, setLoadingConfirm] = useState(false);
  const [open_collab, setOpenCollab] = useState(false);
  const [value, setValue] = useState("");
  const [email_for_expert, setEmailForExpert] = useState(false);
  const [loadingEmailOpen, setLoadingEmailOpen] = useState(false);
  const [available_person, setAvailablePerson] = useState(null);
  const [admin_open, setAdminOpen] = useState(null);
  const [admin_key, setAdminKey] = useState("");
  const [admin_code, setAdminCode] = useState("");
  const [hideSideWidgets, setHideSideWidgets] = useState(false);
  // Initialize access states (all false by default) in the parent

  const transferFiles = async (document_id) => {
    try {
      setLoadingConfirm(true);
      const token = await getOrRefreshFirebaseToken();
      if (document_id === "xml" || document_id === "modif_thermal_xml") {
        let correct = check_files_are_all_zip_or_xml(dropped_files);
        if (!correct) {
          handleClickVariant(
            "Les fichiers doivent être au format .zip",
            "error"
          );
          return;
        }
      }
      if (document_id === "mo") {
        let correct = check_files_are_all_zip_or_xml(dropped_files);
        if (!correct) {
          handleClickVariant(
            "Les fichiers doivent être au format .zip",
            "error"
          );
          return;
        }
      }
      await transferFolderFiles(document_id, id, dropped_files, token, prefix);
      let repo_name = await translateDocumentId(document_id);
      await addActivityLog(
        "Documents déposés " + repo_name,
        folderData.ref,
        null,
        null,
        "file_drop",
        prefix
      );

      await fetchFiles();
      setDroppedFiles([]);
      setDroppedExists(false);
      handleFetchData();
      setLoadingConfirm(false);
    } catch (error) {
      console.error("Error transferring files:", error);
      setLoadingConfirm(false);
    }
  };

  const resetDroppedFiles = () => {
    setDroppedFiles([]);
    setDroppedExists(false);
  };

  const [access_loading, setAccessLoading] = useState(false);

  const [event_description, setEventDescription] = useState("");

  const [infiltreaMemberName, setInfiltreaMemberName] = useState("");
  const [token, setToken] = useState("");

  const getInfiltreaMemberName = async () => {
    if (infiltrea) {
      const member = await getUserById(infiltrea[0].member);
      return member.display_name;
    }
    return "";
  };
  const [folder_audit, setFolderAudit] = useState({
    prepare: { documents: [] },
    process: { documents: [] },
    finalised: { documents: [] },
  });

  const handleSetFolderAudit = (documents) => {
    let audit = {
      prepare: {
        documents: documents.filter((doc) => doc.audit_type === "prepare"),
      },
      process: {
        documents: documents.filter((doc) => doc.audit_type === "process"),
      },
      finalised: {
        documents: documents.filter(
          (doc) => !["prepare", "process"].includes(doc.audit_type)
        ),
      },
    };
    setFolderAudit(audit);
  };

  useEffect(() => {
    if (infiltrea) {
      getInfiltreaMemberName().then((name) => {
        setInfiltreaMemberName(name); // Update state with the fetched member name
      });
    }
  }, [infiltrea]); // Runs whenever `infiltrea` changes

  const users = [
    { email: "ddd@gmail.com", display_name: "Alexis" },
    { email: "dfgf@gmail.com", display_name: "Jon" },
  ];
  const fetchFiles = async () => {
    if (currentUser) {
      try {
        // Fetch user data
        const user = await getUserById(currentUser.uid);

        // Fetch organization data using user's org reference

        const folder = await getDocDataById("folder", id);
        const modif_thermal_photo_document = await getDocDataByRef(
          folder.modif_thermal_photo_document
        );

        const thermal = {
          id: "thermal",
          name: "Documents étude thermique",
          state: folder.thermal?.state,
          viewers_id: folder.thermal?.viewers_id,
        };

        const xml = {
          id: "xml",
          name: "XML (zippé)",
          state: folder.xml?.state,
          viewers_id: folder.thermal?.viewers_id,
        };
        const modif_thermal = {
          id: "modif_thermal",
          name: "Mise à jour étude thermique",
          state: folder.modif_thermal?.state,
          viewers_id: folder.modif_thermal?.viewers_id,
        };
        let modif_thermal_photo = modif_thermal_photo_document;
        modif_thermal_photo.modif_thermal = true;

        const rapport = {
          id: "rapport",
          name: "Rapports de fin de chantier",
          state: folder.rapport?.state,
          viewers_id: folder.rapport?.viewers_id,
        };
        const rapport_architecte = {
          id: "rapport_architecte",
          name: "Rapports Architecte",
          state: folder.rapport_architecte?.state,
          viewers_id: folder.rapport_architecte?.viewers_id,
        };

        let documents = await getArrayDocDataByRef(folder.documents);

        let documentsarchi = await getArrayDocDataByRef(
          folder.pieces_pmr ? folder.pieces_pmr : []
        );

        // add to documents to documentarchi  with pmr = true
        for (let document of documents) {
          if (document.pmr) {
            documentsarchi.push(document);
            documents = documents.filter((doc) => doc.id !== document.id);
          }
        }

        setFolderData(folder);
        setReglementData(folder.reglement);
        await handleGetAllTempUrls();
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    }
  };

  const handleFetchMessages = async (folder = null) => {
    try {
      let folderconv = null;
      const token = await getOrRefreshFirebaseToken();
      let _ = null;
      if (!folder) {
        [folder] = await Promise.all([getDocDataById("folder", id)]);
        [_, folderconv] = await Promise.all([
          getTemporaryUrl(token, "messages", "none", id, prefix),
          getDocDataByRef(folder.folderconv),
        ]);
      } else {
        [_, folderconv] = await Promise.all([
          getTemporaryUrl(token, "messages", "none", id, prefix),
          getDocDataByRef(folder.folderconv),
        ]);
      }

      // Fetch messages based on folderconv data
      const messages = await getArrayDocDataByRef(folderconv.messages);

      // Set the state with the retrieved data
      setFolderData(folder);
      setReglementData(folder.reglement);
      setMessages(messages);
    } catch (error) {
      console.error("Error fetching messages:", error);
    }
  };

  const handleGetAllTempUrls = async (token = null) => {
    if (!token) {
      token = await getOrRefreshFirebaseToken();
    }
    await getTemporaryUrl(token, "all", "none", id, prefix);
  };

  const refreshFolder = (data) => {
    const folder = data;
    setFolderData(folder);
    setReglementData(folder.reglement);
  };

  const [loadingClientExperts, setLoadingClientExperts] = useState(false);
  const [page_state, setPageState] = useState("start");

  const handleInitiateSession = async () => {
    try {
      listenDocDataById("folder", id, refreshFolder);
      let folder = await getDocDataById("folder", id);

      if (!folder) {
        setPageState("error");
      } else {
        if (folder.client_type === "constructor") {
          setPageState("error");
        } else if (impersonate === false) {
          navigateWorkspace(
            "/smsportal/" +
              folder.id +
              "?auth_type=folder&redirect_url=folderportal/" +
              id
          );
        }
      }
      // Fetch user data
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const handleFetchData = async () => {
    if (currentUser) {
      try {
        try {
          const user = await getUserById(currentUser.uid);
          if (user && impersonate === false) {
            console.error("User found and not impersonation is not allowed.");
            return;
          }
        } catch (error) {
          console.error("Error fetching user data:", error);
        }
        // Parallel fetch for user and folder data
        const [folder] = await Promise.all([getDocDataById("folder", id)]);

        if (folder === null) {
          handleClickVariant("Dossier introuvable", "error");
          navigateWorkspace("/folders");
        }

        if (!initiated) {
          setInitiated(true);
          await addActivityLog(
            "Ouverture du dossier",
            folder.ref,
            null,
            null,
            "folder_opened",
            prefix
          );
        }
        if (
          !particulierActivated(folder) &&
          folder.client_type === "architect"
        ) {
          setPageState("architect");
        }

        // Parallel fetch for org and folder-related data based on org type
        let master = await getOrgDataById(folder.master_id);

        // Fetch remaining data
        let [
          modif_thermal_photo_document,
          master_users,
          operators,
          conductor,
          experts,
          all_experts,
          access_documents_docs,
          documents,
          _,
          _2,
          emails,
          documentsarchi,
          available_persons,
        ] = await Promise.all([
          getDocDataByRef(folder.modif_thermal_photo_document),
          getArrayDocDataByID("user", master.users_id),
          folder.members_id
            ? getArrayDocDataByID("user", folder.members_id)
            : Promise.resolve([]),
          folder.conductor_id
            ? getUserById(folder.conductor_id)
            : Promise.resolve(null),
          folder.experts_o
            ? getArrayDocDataByID("org", folder.partners_id)
            : Promise.resolve([]),
          queryCollection("org", [
            { field: "type", operator: "==", value: "expert" },
            {
              field: "masters_id",
              operator: "array-contains",
              value: master.id,
            },
          ]),
          getArrayDocDataByRef(folder.documents),
          getDocumentsByFolderRef(folder.ref),
          handleGetAllTempUrls(token),
          handleFetchMessages(folder),
          queryCollection(
            "email_sent",
            [
              { field: "org_id", operator: "==", value: master.id },
              { field: "folder_ref", operator: "==", value: folder.ref },
            ],
            1000,
            "date",
            "desc"
          ),

          getArrayDocDataByRef(folder.pieces_pmr ? folder.pieces_pmr : []),
          queryCollection(
            "user",
            [{ field: "org_id", operator: "==", value: master.id }],
            1,
            "tracking.last_connection",
            "desc"
          ),
        ]);
        // add to documents to documentarchi  with pmr = true
        for (let document of documents) {
          if (document.pmr) {
            documentsarchi.push(document);
            documents = documents.filter((doc) => doc.id !== document.id);
          }
        }
        if (available_persons.length > 0) {
          setAvailablePerson(available_persons[0]);
        }

        setInfiltrea(folder.infiltrea);

        modif_thermal_photo_document.modif_thermal = true;

        const all_operators = master_users.filter(
          (user) => user.role === "operator"
        );
        const operator_options = all_operators.map((operator) => ({
          label: operator.display_name,
          value: operator.id + "?type=operator",
        }));

        // map a dict wuth the display name and the id

        const expert_options = all_experts.map((expert) => ({
          label: expert.name,
          value: expert.id + "?type=expert",
        }));

        access_documents_docs = access_documents_docs.sort((a, b) =>
          a.name.includes("BE -") ? -1 : 1
        );

        let access_documents = [...access_documents_docs];

        const modif_thermal = {
          id: "modif_thermal",
          name: "Mise à jour étude thermique",
          state: folder.modif_thermal?.state,
          viewers_id: folder.modif_thermal?.viewers_id,
        };

        const rapport = {
          id: "rapport",
          name: "Rapports de fin de chantier",
          state: folder.rapport?.state,
        };
        const rapport_architecte = {
          id: "rapport_architecte",
          name: "Rapports Architecte",
          state: folder.rapport_architecte?.state,
        };

        let blocks =
          folder.folder_type === "infiltro"
            ? [
                {
                  id: "xml",
                  name: "Fichier XML (zippé)",
                  icon: "file",
                  state: folder.xml?.state,
                  viewers_id: folder.thermal?.viewers_id,
                  title: "Dépôt du fichier XML",
                  current: false,
                },
              ]
            : [];
        console.log("folder", folder);
        for (let document of documents) {
          console.log("document", document);

          if (document.icon === "file") {
            blocks.push({
              id: document.id,
              name: document.name,
              icon: document.icon,
              state: document.state,
              viewers_id: document.viewers_id,
              title: "Dépôt de " + document.name,
              ref: document.ref,
              current: false,
              audit_type: document.audit_type,
              description: document.description,
            });
          } else if (
            document.icon === "sign" &&
            document.state !== "locked" &&
            document.documentxx?.id !== "fffff"
          ) {
            blocks.push({
              id: document.id,
              name: document.name,
              icon: document.icon,
              state: document.state,
              viewers_id: document.viewers_id,
              title: "Signature de " + document.name,
              champs: document.champs,
              ref: document.ref,
              current: false,
              audit_type: document.audit_type,
              description: document.description,
            });
          } else if (
            document.documentxx?.id === "fffff" &&
            document.state !== "locked" &&
            !folder.use_facture_mat
          ) {
            blocks.push({
              id: document.id,
              name: document.name,
              icon: document.icon,
              state: document.state,
              viewers_id: document.viewers_id,
              title: "Signature de " + document.name,
              champs: document.champs,
              ref: document.ref,
              current: false,
              audit_type: document.audit_type,
              description: document.description,
            });
          } else if (
            document.documentxx?.id === "fffff" &&
            folder.use_facture_mat
          ) {
            blocks.push({
              id: document.id,
              name: document.name,
              icon: "file",
              state: document.state,
              viewers_id: document.viewers_id,
              title: "Dépôt de facture de matériaux",
              champs: document.champs,
              ref: document.ref,
              current: false,
              audit_type: document.audit_type,
              description: document.description,
            });
          } else if (document.icon === "photo" && document.state !== "locked") {
            blocks.push({
              id: document.id,
              name: document.name,
              icon: document.icon,
              state: document.state,
              viewers_id: document.viewers_id,
              title: "Dépôts de Photos",
              champs: document.champs,
              ref: document.ref,
              current: false,
              audit_type: document.audit_type,
              description: document.description,
            });
          }
        }
        if (folder.modif_thermal.activated) {
          blocks.push({
            id: "modif_thermal",
            name: "Mise à jour étude thermique",
            icon: "file",
            state: folder.modif_thermal?.state,

            viewers_id: folder.modif_thermal?.viewers_id,
            title: "Dépôt de la mise à jour de l'étude thermique",
            current: false,
          });
          blocks.push({
            id: "modif_thermal_xml",
            name: "Xml de mise à jour",
            icon: "file",
            state: folder.modif_thermal?.xml?.state,

            viewers_id: folder.modif_thermal?.viewers_id,
            title: "Dépôt du fichier XML de la mise à jour",
            current: false,
          });
        }
        // loop with i
        if (folder.reglement_state !== "done") {
          for (let i = 0; i < blocks.length; i++) {
            if (
              blocks[i].state === null ||
              blocks[i].state === undefined ||
              blocks[i].state === "locked" ||
              blocks[i].state === "missing" ||
              blocks[i].state === "open"
            ) {
              blocks[i].current = true;
              break;
            }
          }
        }
        let viewers_blocks = [];
        for (let i = 0; i < blocks.length; i++) {
          if (true) {
            viewers_blocks.push(blocks[i]);
          }
        }

        if (false && folder.reglement_state === "done") {
          viewers_blocks.push({
            id: "rapport",
            name: "Rapports de fin de chantier",
            icon: "rapport",
            state: "done",
            title: "Rapports",
            current: true,
          });
        }
        // put XML first, then ones that contain "BE -" in the name, then don't sort the rest

        viewers_blocks = viewers_blocks.sort((a, b) => {
          if (a.id === "xml") return -1; // XML should always be first
          if (b.id === "xml") return 1;
          if (a.name.includes("BE -") && !b.name.includes("BE -")) return -1;
          if (!a.name.includes("BE -") && b.name.includes("BE -")) return 1;
          return 0; // Keep the original order for the rest
        });
        setBlocks(viewers_blocks);
        handleSetFolderAudit(viewers_blocks);

        access_documents.push(modif_thermal);

        // Set state with the fetched data

        setFolderData(folder);
        setReglementData(folder.reglement);

        setOperators(operators);
        setAllOperators(all_operators);
        setConductor(conductor);
        setAllConductors(all_conductors);

        setToken(token);

        setLoadingData(false);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    }
  };

  const handleDownloadReports = async () => {
    const token = await getOrRefreshFirebaseToken();
    await getTemporaryUrl(token, "all", "none", id, prefix);
    let folder = await getDocDataById("folder", id);
    let rapport_files = folder.rapport.files;
    await addActivityLog(
      "Rapports téléchargés",
      folderData?.ref,
      null,
      null,
      "reports_downloaded",
      prefix
    );
    downloadRapport(rapport_files, folder.nom);
    handleClickVariant("Rapports téléchargés", "success");
  };

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.altKey && e.key === "p") {
        if (admin_open === null) {
          setAdminOpen(1);
        } else {
          setAdminOpen(null);
        }
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [admin_open]);

  const [loading_drop = false, setLoadingDrop] = useState(false);
  const onDelete = (file) => {
    const new_files = dropped_files.filter((f) => f !== file);
    setDroppedFiles(new_files);
    if (new_files.length === 0) {
      setDroppedExists(false);
    }
  };
  const onDropZone = async (files) => {
    setLoadingDrop(true);
    const token = await getOrRefreshFirebaseToken();

    let new_files = [];

    new_files = files.filter(
      (file) => !dropped_files.map((filed) => filed.name).includes(file.name)
    );

    let new_drop_files = [];

    for (let i = 0; i < new_files.length; i++) {
      let res = await uploadDropZoneTemporary(
        token,
        new_files[i],
        new_files[i].name,
        prefix
      );
      let url = res.url;
      let name = res.name;
      let size = new_files[i].size;
      new_drop_files = [
        ...new_drop_files,
        { url: url, name: name, size: size },
      ];
    }
    let new_dropped_files = [...dropped_files, ...new_drop_files];
    setDroppedFiles(new_dropped_files);
    setDroppedExists(true);

    setLoadingDrop(false);
  };

  const sendToDrop = async (file) => {
    setLoadingDrop(true);

    let new_files = [];

    const file_url = file.url;
    const file_name = file.name;
    const bytes = await fetch(file_url).then((res) => res.arrayBuffer());

    let res = await uploadDropZoneTemporary(token, bytes, file_name, prefix);
    let url = res.url;
    let name = res.name;
    let size = res.size;
    new_files = [...new_files, { url: url, name: name, size: size }];

    setDroppedFiles(new_files);
    setDroppedExists(true);

    setLoadingDrop(false);
  };

  function setBlockAsCurrent(id) {
    if (!id) return;
    if (
      ["done", "wait"].includes(blocks.find((block) => block.id === id)?.state)
    )
      return;
    let new_blocks = blocks.map((block) => {
      if (block.id === id) {
        block.current = true;
      } else {
        block.current = false;
      }
      return block;
    });
    setBlocks(new_blocks);
  }

  const [initiated, setInitiated] = useState(false);
  useEffect(() => {
    if (!loading) {
      if (currentUser) {
        handleFetchData(); // Fetch user data when currentUser is available
        setPageState("folder");
      } else if (!impersonate) {
        handleInitiateSession(); // Fetch user data when currentUser is available
      }
    }
  }, [currentUser, loading]); // Dependency array ensures this runs when currentUser changes

  const { enqueueSnackbar } = useSnackbar();
  const handleClickVariant = (message, variant) => {
    enqueueSnackbar(message, { variant });
  };

  const handleOpenTag = (index) => {
    setTagOpen(true);
    setTagIndex(index);
  };

  function hideParttially(str) {
    return str.slice(0, 3) + "****" + str.slice(-3);
  }

  if (page_state === "start") {
    return (
      <div className="flex flex-col w-full h-full  overflow-auto align-middle items-center justify-center">
        <div className="flex flex-col w-fit h-fit p-4 gap-2 bg-white rounded-3xl shadow-xl overflow-auto items-center">
          <Player
            autoplay
            loop
            src={loadingAnimation}
            style={{ height: "100px", width: "200px" }}
          />
        </div>{" "}
      </div>
    );
  }

  if (page_state === "error") {
    return (
      <div className="flex flex-col w-full h-full  overflow-auto align-middle items-center justify-center">
        <div className="flex flex-col w-fit h-fit p-4 gap-2 bg-white rounded-3xl shadow-xl overflow-auto items-center">
          <Icon1 icon_name="warning" fill="" />
          <div className="text-h2 text-center">Ce lien a expiré</div>
        </div>{" "}
      </div>
    );
  }

  if (page_state === "architect") {
    return (
      <div className="flex flex-col w-full h-full overflow-auto align-middle items-center justify-center">
        <div className="flex flex-col w-fit h-fit p-4 gap-2 max-w-c400  bg-white rounded-3xl shadow-xl overflow-auto items-center">
          <Icon1 icon_name="warning" fill="" />
          <div className="text-h2 text-center">
            Ce dossier est un dossier architecte, le particulier n'a acès qu'aux
            paiements
          </div>
        </div>{" "}
      </div>
    );
  }

  // loading || !currentUser || !userData
  if (page_state === "folder" && (loading || !currentUser || loadingData)) {
    return (
      <div className="w-full h-full  flex flex-row align-top">
        <SmallSpinner />
      </div>
    );
  }

  return (
    <div className="w-full h-full overflow-auto flex flex-col pb-40">
      <Modal1 isOpen={photoOpen} onClose={() => setPhotoOpen(false)}>
        <div className="bg-neutral-200 flex flex-col  w-c1k rounded-3xl ">
          <Photo
            validation={false}
            orgData={orgData}
            document={blocks.find((b) => b.current)}
            folder={folderData}
            onClose={() => setPhotoOpen(false)}
            onFetch={handleFetchData}
            userData={null}
          />{" "}
        </div>
      </Modal1>{" "}
      <div className="text-hx font-bold mt-6 pl-6 w-c200 mb-6">
        Page dossier
      </div>
      <div className="w-full max-w-c900 pl-4">
        {folderData.folder_type === "audit" && (
          <TimelineFolderAudit
            folderData={folderData}
            orgData={null}
          ></TimelineFolderAudit>
        )}
        {folderData.folder_type === "infiltro" && (
          <TimelineFolder
            folderData={folderData}
            orgData={null}
          ></TimelineFolder>
        )}
      </div>
      <div className="w-full h-fit flex xl:flex-row flex-col justify-start  mt-6 ">
        {/* Left Column: Takes all available space */}
        {!hideSideWidgets && (
          <div className="h-fit flex flex-col pl-4 w-fit ">
            {" "}
            <Space y={15} />
            <div className="text-hx2 flex flex-col pl-2 gap-2 w-fit ">
              {blocks.filter((block) => block.icon !== "rapport").length ===
                0 && (
                <div className="flex flex-col  w-full rounded-xl items-center h-fit my-1 bg-red-50 p-2 border-l-3 border-red-400 ">
                  <div className="text-h2 text-red-400 font-medium   gap-2 flex flex-row items-center">
                    <Icon1 icon_name="warning" fill="red" size={25} />
                    Vous n'avez accès à aucun document
                  </div>
                </div>
              )}
            </div>
            <Space y={30} />
            <div className="flex flex-col max-h-[50vh] overflow-y-auto gap-2 w-fit">
              {folderData.folder_type === "audit" && (
                <div className="w-c300 flex flex-col gap-1">
                  <Collapsible title={"Préparation du projet"}>
                    <div className="flex flex-col pt-2  gap-2 w-fit">
                      {blocks
                        .filter((block) => block.audit_type === "prepare")
                        .map((block, index) => (
                          <div key={index}>
                            <ActionBlock
                              onClick={() => {
                                // setSelectedBlock(block);

                                setBlockAsCurrent(block.id);
                              }}
                              block={block}
                            ></ActionBlock>
                          </div>
                        ))}
                    </div>
                  </Collapsible>
                  <Collapsible title={"Dépôt du dossier"}>
                    <div className="flex flex-col  pt-2   gap-2 w-fit">
                      {blocks
                        .filter((block) => block.audit_type === "process")
                        .map((block, index) => (
                          <div key={index}>
                            <ActionBlock
                              onClick={() => {
                                // setSelectedBlock(block);

                                setBlockAsCurrent(block.id);
                              }}
                              block={block}
                            ></ActionBlock>
                          </div>
                        ))}
                    </div>
                  </Collapsible>
                  <Collapsible title={"Finalisation du projet"}>
                    <div className="flex flex-col  pt-2   gap-2 w-fit">
                      {blocks
                        .filter(
                          (block) =>
                            !["prepare", "process"].includes(block.audit_type)
                        )
                        .map((block, index) => (
                          <div key={index}>
                            <ActionBlock
                              onClick={() => {
                                // setSelectedBlock(block);

                                setBlockAsCurrent(block.id);
                              }}
                              block={block}
                            ></ActionBlock>
                          </div>
                        ))}
                    </div>
                  </Collapsible>
                </div>
              )}
              {folderData.folder_type !== "audit" && (
                <>
                  {" "}
                  {blocks.map((block, index) => (
                    <div key={index}>
                      <ActionBlock
                        onClick={() => {
                          // setSelectedBlock(block);

                          setBlockAsCurrent(block.id);
                        }}
                        block={block}
                      ></ActionBlock>
                    </div>
                  ))}
                </>
              )}
            </div>
            <Space y={30} />
          </div>
        )}
        <div className="xl:flex-row flex-col flex w-full  h-fit max-w-c1p2k ">
          <div className="flex flex-col pl-4 h-fit  w-full  ">
            {blocks.length !== 0 &&
              blocks.filter((block) => block.current).length === 0 && (
                <div className="flex flex-col  w-full rounded-2xl items-center h-fit   max-w-c1p2k">
                  <div className="text-h1 text-shadow_25 font-medium p-3 my-3 gap-2 flex flex-col justify-center items-center">
                    <Icon1 icon_name="done2" fill="lightgreen" size={30} />
                    Tout est en ordre
                  </div>
                </div>
              )}

            {!hideSideWidgets && <Space y={5} />}

            {blocks
              .filter((block) => block.current)
              .map((block, index) => (
                <div
                  key={index}
                  className="flex flex-col h-fit w-full border-1 max-w-c1p2k border-shadow_10 bg-white shadow-md rounded-2xl items-center  "
                >
                  {(block.id === "xml" || block.id === "modif_thermal_xml") && (
                    <div className="flex flex-col gap-1 my-3 p-3">
                      <div className="text-h1 font-medium ">{block.title}</div>
                      <div className="text-h3 mt-2">RE2020 : Format .zip</div>
                      <div className="text-h3  ">
                        RT2012 : Format .zip ou .xml
                      </div>
                    </div>
                  )}
                  {block.id !== "xml" && block.id !== "modif_thermal_xml" && (
                    <div className="text-h1 font-medium p-3 my-3 flex flex-row items-center gap-2">
                      <span>{block.title}</span>
                      {blocks.find((b) => b.id === block.id)?.description && (
                        <Tippy
                          content={
                            <div
                              className="bg-inherit p-3 rounded-lg shadow-xl"
                              style={{ minWidth: "250px", maxWidth: "350px" }}
                            >
                              <div className="text-xs text-white whitespace-pre-wrap">
                                {blocks.find((b) => b.id === block.id)?.description}
                              </div>
                            </div>
                          }
                          interactive={true}
                          placement="right"
                          appendTo={() => window.document.body}
                          popperOptions={{
                            strategy: "fixed",
                          }}
                        >
                          <div style={{ cursor: "pointer" }}>
                            <Icon1 icon_name="question" size={20} fill="grey" />
                          </div>
                        </Tippy>
                      )}
                    </div>
                  )}
                  <div className="border-b-1 border-shadow_10 w-full"></div>

                  {block.icon === "file" && (
                    <div className="w-full px-4">
                      <Dropzone2
                        onDrop={onDropZone}
                        files={dropped_files || []}
                        onDelete={onDelete}
                        loading={loading_drop}
                        only_zip={
                          block.id === "xml" || block.id === "modif_thermal_xml"
                        }
                        handleClickVariant={handleClickVariant}
                      ></Dropzone2>
                      <div className="w-full mb-5 justify-center flex flex-row ">
                        <div
                          className={`flex items-center rounded-full w-fit  px-6 py-2 text-white font-medium
                    ${dropped_files.length === 0 ? "bg-gray-300" : " bg-primary  cursor-pointer hover:shadow-lg"}`}
                          onClick={() => {
                            dropped_files.length !== 0
                              ? transferFiles(block.id)
                              : {};
                          }}
                        >
                          Confirmer{" "}
                          <SmallSpinner
                            margin={6}
                            loading={loadingConfirm}
                            size={25}
                          />
                        </div>
                      </div>
                    </div>
                  )}
                  {block.icon === "sign" && (
                    <SignBlockFolder
                      folderData={folderData}
                      id={id}
                      orgData={orgData}
                      clientData={clientData}
                      prefix={prefix}
                      block={block}
                      setBlock={() =>
                        setBlocks(
                          blocks.map((b) => (b.id === block.id ? block : b))
                        )
                      }
                      blocks={blocks}
                      setBlocks={setBlocks}
                      handleClickVariant={handleClickVariant}
                      fetchFiles={fetchFiles}
                      onRefresh={handleFetchData}
                      setHideSideWidgets={setHideSideWidgets}
                      particulier={true}
                      impersonate={impersonate}
                    ></SignBlockFolder>
                  )}

                  {block.icon === "photo" && (
                    <div className="w-full mb-5 justify-center flex flex-col gap-4 mt-4 items-center">
                      <div className="w-full mb-5 justify-center flex flex-row gap-4 mt-4 items-center">
                        <div
                          className={`flex  rounded-full w-fit   px-10 py-3 text-white font-medium
           bg-primary  cursor-pointer hover:shadow-lg`}
                          onClick={() => setPhotoOpen(true)}
                        >
                          Déposer les photos
                        </div>
                      </div>
                      <div className="w-full mb-5 justify-center flex flex-row gap-4 mt-4 items-center">
                        <div
                          className={`flex  rounded-full w-fit   px-10 py-3 text-white font-medium
           bg-primary  cursor-pointer hover:shadow-lg`}
                          onClick={() => handleFetchData()}
                        >
                          Confirmer
                        </div>
                      </div>
                    </div>
                  )}
                  {block.icon === "rapport" && false && (
                    <div className="w-full mb-5 justify-center flex flex-col gap-4 mt-4 items-center">
                      <div className="w-full mb-5 justify-center flex flex-row gap-4 mt-4 items-center">
                        <div
                          className={`flex  rounded-full w-fit   px-10 py-3 text-white font-medium
           bg-primary  cursor-pointer hover:shadow-lg`}
                          onClick={handleDownloadReports}
                        >
                          Télécharger les rapports de fin de chantier
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              ))}
          </div>
          {/* Right Column: Fixed width */}
          {!hideSideWidgets && (
            <div className="h-fit flex flex-col  min-w-c400 px-4 align-top justify-end ">
              <div className=" w-full flex flex-col min-h-fit  ">
                <FolderChat
                  folder={folderData}
                  messages={messages}
                  orgData={{
                    id: "particulier",
                    type: "client",
                    name: "Particulier",
                  }}
                  onUpdate={handleFetchMessages}
                  dragging={dropped_exists}
                  uploadedlist={dropped_files}
                  resetDroppedFiles={resetDroppedFiles}
                  sendDrop={sendToDrop}
                  navigateWorkspace={navigateWorkspace}
                  workspaceData={{}}
                  userData={null}
                ></FolderChat>
              </div>

              <Space y={50} />
            </div>
          )}
        </div>
      </div>{" "}
    </div>
  );
}

export default FolderPortal;

export const ActionBlock = ({ block, onClick }) => {
  return (
    <div onClick={onClick} className="flex flex-col items-center   ">
      {block.icon === "rapport" && (
        <>
          <div className="h-4 border-l-1 border-violet-300"></div>

          <div
            className={`flex flex-col rounded-xl px-3 py-1 gap-1 cursor-pointer  w-c250 shadow-md ${block.current === true ? "border-violet-300 mt-2 border-2 text-black" : "hover:border-1 hover:border-violet-300 border-shadow_10 text-shadow_50"}   
           
           `}
          >
            <div className="text-h3 font-medium ">
              {block.title ? block.title : "Titre"}
            </div>
            <div className="flex flex-col gap-1 mt-2">
              {block.id === "rapport-architect" &&
                block.paid_count.map((paid, index) => (
                  <div
                    key={index}
                    className="text-h3 text-indigo-500 font-semibold flex flex-row items-center justify-between  "
                  >
                    <div className="w-c200">paiement {index + 1}</div>
                    {paid ? (
                      <Icon1 icon_name="done2" fill="#61CD65" size={20}></Icon1>
                    ) : (
                      <Icon1 icon_name="horloge" fill="grey" size={20}></Icon1>
                    )}
                  </div>
                ))}
              {block.id === "rapport-constructor" &&
                block.paid_count.map((paid, index) => (
                  <div
                    key={index}
                    className="text-h3 text-indigo-500 font-semibold flex flex-row items-center justify-between  "
                  >
                    <div className="w-c150">emplacement {index + 1}</div>
                    {paid ? (
                      <Icon1 icon_name="done2" fill="#61CD65" size={20}></Icon1>
                    ) : (
                      <Icon1 icon_name="horloge" fill="grey" size={20}></Icon1>
                    )}
                  </div>
                ))}
            </div>
          </div>
        </>
      )}
      {block.state === "blocked" && (
        <>
          {block.current && (
            <div className="h-4 w-full flex flex-row justify-center items-center">
              <div className="h-4 border-l-1 border-shadow_25 w-1"></div>
            </div>
          )}
          <div
            className={`flex flex-col rounded-xl bg-white px-3 py-1 gap-1 cursor-pointer  w-c250  ${block.current === true ? "border-red-400 shadow-md mt-2 border-2 text-black" : "border-1  hover:shadow-md hover:border-red-400 border-red-200 text-shadow_50"}   
           
           `}
          >
            <div className="text-h3 font-medium ">
              {block.title ? block.title : "Titre"}
            </div>
            <div className="flex flex-col gap-1 ">
              <div className="text-h3 text-red-500 font-semibold flex flex-row items-center justify-between  ">
                <div className="w-c200">dépôt impossible</div>

                <Icon1 icon_name="forbidden" fill="#ea1519" size={20}></Icon1>
              </div>
            </div>
          </div>
        </>
      )}
      {block.icon !== "rapport" && block.state != "blocked" && (
        <div
          className={`cursor-pointer rounded-lg ${block.current === false ? "hover:border-1 hover:border-blue-300" : ""}`}
        >
          <div
            className={`flex flex-col rounded-lg px-3  gap-1 bg-green-100 w-c250 ${
              block.current
                ? "shadow-md  border-2 border-blue-300 mt-2 py-1"
                : block.state === "done" || block.state === "wait"
                  ? "py-0.5 "
                  : "py-0.5"
            }`}
            style={{
              backgroundColor:
                block.state === "done" || block.state === "wait"
                  ? "rgba(0, 255, 9, 0.05)"
                  : block.current
                    ? "rgba(255, 255, 255, 1)"
                    : block.state === "special"
                      ? "rgba(230, 255, 255, 1)"
                      : block.state === "missing"
                        ? "rgba(255, 0, 9, 0.05)"
                        : "rgba(0, 0, 0, 0.03)",
            }}
          >
            <div
              className="text-h3 text-black font-medium"
              style={{
                color:
                  block.state === "done" || block.state === "wait"
                    ? "#61CD65"
                    : block.current
                      ? "rgba(0, 0, 0, 1)"
                      : block.state === "missing"
                        ? "rgba(205, 97, 97, 1)"
                        : "rgba(0, 0, 0, 0.5)",
              }}
            >
              {block.title ? block.title : "Titre"}
            </div>
            <div className="text-h4 text-shadow_50 ">
              {block.state === "done"
                ? ""
                : block.state === "special"
                  ? ""
                  : block.state === "wait"
                    ? "En attente de validation"
                    : block.state === "missing"
                      ? "Nécessite une correction"
                      : block.current
                        ? block.state === "missing"
                          ? "Nécessite une correction"
                          : block.id === "rapport"
                            ? "Disponibles"
                            : "En cours"
                        : ""}
            </div>
          </div>
        </div>
      )}{" "}
    </div>
  );
};

export const check_files_are_all_zip = (dropped_files) => {
  for (let file of dropped_files) {
    if (!file.name.endsWith(".zip")) {
      return false;
    }
  }
  return true;
};
